import { makeSubmitData } from "api/makeApiRequestType/makeSubmitData";

type Params = {
	senderUid: string;
	recipientUid: string;
	message: string;
};

export const sendPrivateMessage = makeSubmitData<Params>("privateMessage");
